angular.module('app').config(tourContentsRouting);

function tourContentsRouting($routeProvider) {
  $routeProvider
    .when('/tour_contents', {
      // ?WSID=
      pageTitle: 'TOURS',
      template: '<tour-contents-page></tour-contents-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      menu: 'websites',
      accessPermission: 'index_tour_accountadmin',
      authReq: true,
    })
    .when('/tour_contents/new', {
      pageTitle: 'ADD_CONTENT',
      template: '<tour-content-page></tour-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        //   ajs: true,
      },
      // breadcrumb: {
      //   label: 'TOURS',
      //   parent: 'tour_contents',
      // },
      menu: 'websites',
      accessPermission: 'create_tour_accountadmin',
      authReq: true,
    })
    .when('/tour_contents/:id', {
      pageTitle: 'CONTENT_OVERVIEW',
      template: '<tour-content-page></tour-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        //   ajs: true,
      },
      // resolve: {
      //   params: function () {
      //     return 'WSID=123';
      //   },
      // },
      // breadcrumb: {
      //   label: 'TOURS',
      //   parent: 'tour_contents',
      // },
      menu: 'websites',
      accessPermission: 'show_tour_accountadmin',
      authReq: true,
    });
}

tourContentsRouting.$inject = ['$routeProvider'];
